import React from "react";

export const Quotes = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={122}
            height={86}
            viewBox="0 0 122 86"
            fill="none"
            {...props}
        >
            <path
                d="M122 34.399H95.567l17.623-34.4H86.757l-17.623 34.4v51.6H122v-51.6zM52.866 85.999v-51.6H26.433l17.623-34.4H17.623L0 34.399v51.6h52.866z"
                fill="#FE9235"
            />
        </svg>
    )
}
